import { disableVideo, getUserVideos } from "@/lib/api/api"
import { NextResponse } from "next/server"

export enum VideoAction {
    DISABLEVIDEO = "disable"
}

type VideoPatchRequest = {
    userId: string,
    videoId: string,
    videoAction: VideoAction

}

export async function GET(request: Request) {
    const { searchParams } = new URL(request.url)

    const id = searchParams.get("id")

    if (!id) {
        return
    }
    
    const res = await getUserVideos(id);
    
    return NextResponse.json(res)
}

export async function PATCH(request: Request) {
    const params = await request.json() as VideoPatchRequest
    let res: any

    switch (params.videoAction) {
        case VideoAction.DISABLEVIDEO:
            res = await disableVideo(params.userId, params.videoId);
    }

    return NextResponse.json(res)

}